"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DraggableGrid = void 0;
var draggable_grid_1 = require("./draggable-grid");
Object.defineProperty(exports, "DraggableGrid", { enumerable: true, get: function () { return draggable_grid_1.DraggableGrid; } });
exports.default = draggable_grid_1.DraggableGrid;
//# sourceMappingURL=index.js.map